<template>
    <div class="body">
        <div class="btn" @click="sureToRecharge()"></div>
        <!--显示活动弹窗-->
        <div class="v-dialog" v-if="isDialogShow">
            <div class="v-dialog-bg"></div>
            <div class="v-dialog-content">
                <div class="input">{{ input }}</div>
                <div class="sumbit_btn" @click="sureToRecharge()"></div>
                <div class="v-dialog-close">
                    <img src="@/assets/dzp/dialog_close.png" alt="" @click="isDialogShow = false" />
                </div>
            </div>
        </div>
        <!-- 修改密码框   -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp"
            style="z-index: 2000; min-height: 25%; min-width: 80%;" v-show="showPasswordPanel"
            :style="{ top: passwordPanelTop + '%' }">

            <van-icon name="cross" class="icon-cross" @click="sureToRecharge()" />

            <!-- 密码输入框 -->
            <p>设置开户支付密码：</p>
            <van-password-input :value="password" :focused="passwordKeyboard" @focus="passwordOnfocus()" />

            <!-- 再次确认密码输入框 -->
            <p>再次确认开户密码：</p>
            <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard"
                @focus="confirmPasswordOnfocus()" />
            <div class="confirmChangePassword">
                <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确
                    定</van-button>
            </div>

        </div>

        <!-- 数字键盘 -->
        <van-number-keyboard :z-index="2015" :show="passwordKeyboard" @input="passwordOnInput" @delete="passwordOnDelete"
            @blur="passwordKeyboard = false" />

        <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
            @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />
        <!-- 数字键盘 end -->
        <!-- 修改密码框 end  -->

        <div class="customer" @click="cust">
            <img src="@/assets/232131.png" alt="">
            <div class="zx">在 线 客 服</div>
        </div>

        <div v-html="payUrl"></div>
        <div class="shareit" v-if="is_WeChat">
            <img class="arrow" src="@/assets/img/arrowhead.png" />
            <div class="follow">支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后 请重新扫码登录进行激活操作<br /></div>
        </div>


    </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
import { wxRequest } from '@/api/user.js'
export default {
    data() {
        return {
            is_WeChat: false,
            payUrl: '',


            isBindPhone: localStorage.getItem("isBindPhone"),
            isBindPhones: this.$store.state.isBindPhone,
            newHome: this.$store.state.newHome,
            newHomes: localStorage.getItem("newHome"),
            input: this.$store.state.recordLoginText,
            isDialogShow: false,
            //设置密码
            password: '',
            confirmPassword: "",
            alreadySetUp: false,
            showPasswordPanel: false,
            passwordKeyboard: false,
            confirmPasswordKeyboard: false,
            passwordPanelTop: 50,


            //当前余额套餐
            currentItem: 0,
            price: 0,
            giftBalance: 0,

            //自定义金额
            popup: false,

            //自定义键盘
            showKeyboard: false,
            definedPrice: '',

            type: '',
            indexActive: '',
        }
    },

    created() {
        this.is_WeChat = false
        if (this.$route.query.row) {
            this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
            this.$nextTick(() => {
                document.forms[0].submit()
            })
        }
    },


    methods: {
        cust() {
            window.location.href = 'https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL'
        },

        /***   修改密码     ***/
        passwordOnfocus() {
            this.passwordKeyboard = true;
            this.confirmPasswordKeyboard = false;
            this.passwordPanelTop = 30;
        },
        passwordOnDelete() {
            this.password = this.password.slice(0, this.password.length - 1);
        },

        passwordOnInput(key) {
            this.password = (this.password + key).slice(0, 6);
        },


        confirmPasswordOnfocus() {
            this.passwordKeyboard = false;
            this.confirmPasswordKeyboard = true;
            this.passwordPanelTop = 30;
        },
        confirmPasswordOnDelete() {
            this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
        },

        confirmPasswordOnInput(key) {
            this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
        },


        cancelChangePassword() {
            this.password = '';
            this.confirmPassword = '';
            this.passwordPanelTop = 50;
            this.showPasswordPanel = false;
        },

        checkPassword() {
            if (this.password.length < 6) {
                Dialog.alert({ message: "请设置六位支付密码" });
                return false;
            }

            if (this.password != this.confirmPassword) {
                Dialog.alert({ message: "两次输入的新密码不一致" });
                return false;
            }
            return true;
        },


        /***   修改密码  end   ***/
        sumbit() {
            this.showPasswordPanel = true;
        },
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', param,
                function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        _this.$router
                            .push({
                                path: "/newUser/home",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    }
                }
            );
        },
        async sureToRecharge() {
            var params = {
                ali: localStorage.getItem("htmlType"),
                iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'),
                amount: 100 * 100, //固定值         
                giftBalance: 0, //固定值 	   
                yucun: 1, //固定值
                payType: 20,// 固定微信支付         

            }
            var postUrl = "order/user/create/priceOrder";
            await wxRequest("sim/pay/type", params, "post").then(res => {
                if (res.data.code == 406) {
                    postUrl = "order/user/create/priceOrderHf";
                    params.payType = 60;
                } else if (res.data.code == 408) {
                    postUrl = "order/ali/user/create/priceOrder";
                    params.payType = 80;
                } else if (res.data.code == 409) {
                    postUrl = "order/ali/user/create/priceOrder/mi";
                    params.payType = 90;
                } else if (res.data.code == 410) {
                    postUrl = "order/ali/user/create/priceOrder/dh";
                    params.payType = 90;
                } else if (res.data.code == 491) {
                    postUrl = "order/ali/user/create/priceOrder/hl";
                    params.payType = 90;
                } else if (res.data.code == 492) {
                    postUrl = "order/ali/user/create/priceOrder/yy";
                    params.payType = 92;
                } else if (res.data.code == 493) {
                    postUrl = "order/ali/user/create/priceOrder/long";
                    params.payType = 90;
                } else if (res.data.code == 494) {
                    postUrl = "order/ali/user/create/priceOrder/huo";
                    params.payType = 93;
                } else if (res.data.code == 498) {
                    postUrl = "order/ali/user/create/priceOrder/bf";
                    params.payType = 98;
                }
            })
            await wxRequest(postUrl, params, "post").then(res => {
                if (res.data.code == 200) {
                    if (params.payType == 50) {//乐刷
                        window.location.href = res.data.data.jspay_url;
                    } else if (params.payType == 20) {//微信第三方
                        var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                            }
                        } else {
                            this.onBridgeReady(param);
                        }

                    } else if (params.payType == 92 || params.payType == 93|| params.payType == 98) {
                        //云游
                        window.location.href = res.data.data;
                    } else if (params.payType == 90) {//微信第三方
                        var param = res.data.data;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                            }
                        } else {
                            this.onBridgeReady(param);
                        }

                    } else if (params.payType == 60) { //汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === 'succeeded') {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => {
                                Dialog.alert({ title: '提示', message: res.result_message });
                            })
                        }
                    } else if (params.payType == 80) {
                        window.location.href = res.data.data;
                    }
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.body {
    .customer {
        position: fixed;
        right: 6px;
        top: 40%;
        width: 40px;
        height: 120px;
        text-align: center;
        color: #FFFFFF;
        background: #75b0ff;
        border-radius: 20px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        writing-mode: vertical-rl;
        font-family: HarmonyOS_Sans_SC_Medium;

        img {
            width: 22px;
            height: 22px;
            margin-bottom: 6px;
        }
    }

    background: url('../../assets/newUser/img/zhibo.png')no-repeat center;
    background-size: 100% 100%;
    width:100%;
    height:100vh;
    position: relative;

    .btn {
        width: 325px;
        position: fixed;
        bottom: 20px;
        left: 0px;
        right: 0px;
        margin: auto;
        height: 64px;
        background: url('../../assets/dzp/6fdec6ce1.png')no-repeat center;
        background-size: 100% 100%;
    }

    .v-dialog {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;

        .v-dialog-bg {
            position: fixed;
            background: rgba(0, 0, 0, .7);
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 100%;
            height: 100%;
        }

        .v-dialog-close {
            width: 22px;
            height: 22px;
            // margin:0 auto;
            // margin-top:20px;
            position: fixed;
            top: 0;
            bottom: -300px;
            left: 0;
            right: 0;
            margin: auto;

            img {
                height: 100%;
                cursor: pointer;
            }
        }

        .v-dialog-content {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 275px;
            height: 210px;
            background: url('../../assets/dzp/t_c.png') no-repeat center;
            background-size: 100% 100%;

            .input {
                background: rgb(255, 255, 255);
                width: 200px;
                height: 40px;
                margin: auto;
                margin-bottom: 10px;
                border-radius: 12px;
                text-align: center;
                line-height: 40px;
                font-size: 25px;
                color: rgb(177, 54, 0);
                position: absolute;
                bottom: 54px;
                display: flex;
                left: 0;
                right: 0;
                justify-content: center;
                align-items: center;
            }

            .sumbit_btn {
                width: 175px;
                height: 46px;
                position: absolute;
                bottom: 8px;
                display: flex;
                left: 0;
                margin: auto;
                right: 0;
                background: url('../../assets/dzp/a2.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
    }
}

.changePasswordPanel-cardSetUp {
    padding: 10px;

    .icon-cross {
        position: absolute;
        right: 10px;
        font-size: 16px;
    }

    p {
        margin: 10px 16px 0 16px;
        line-height: 30px;
    }

    .confirmChangePassword {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        .confirmChangePasswordBtn {
            width: 80px;
            margin: 0 15px;
        }
    }


}

.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}

.shareit img {
    max-width: 100%;
}

.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}

.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}
</style>